/* ============================================================
   RR ALGOLIA ADAPTER v8 — Terra Luna India
   - Fetches up to 40 results for search queries
   - Deduplicates by handle before passing to search overlay
   - Renders results directly in the overlay (no page redirect)
   ============================================================ */

(function () {
  'use strict';

  var APP_ID  = 'KFQUZ00GTS';
  var API_KEY = '015e7b2e984f13fce395654bdce34a76';

  var CANDIDATES    = ['shopify_products_products', 'shopify_products'];
  var resolvedIndex = null;

  var SEARCH_URL = function(idx) {
    return 'https://' + APP_ID + '-dsn.algolia.net/1/indexes/' + idx + '/query';
  };
  var RECOMMEND_URL = 'https://' + APP_ID + '.algolia.net/1/indexes/*/recommendations';

  function rupeesToPaise(val) {
    if (!val && val !== 0) return 0;
    var n = parseFloat(String(val).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function mapHit(hit) {
    var price     = rupeesToPaise(hit.price     || hit.variants_min_price              || 0);
    var compareAt = rupeesToPaise(hit.compare_at_price || hit.variants_min_compare_at_price || 0);

    var image = '';
    if (hit.image && hit.image.src)                      image = hit.image.src;
    else if (Array.isArray(hit.images) && hit.images[0]) image = hit.images[0];
    else if (typeof hit.image === 'string')               image = hit.image;
    if (image && image.indexOf('?') === -1)               image += '?width=480';

    return {
      handle:    hit.handle || '',
      title:     hit.title  || '',
      vendor:    hit.vendor || '',
      url:       hit.url    || '/products/' + (hit.handle || ''),
      price:     price,
      compareAt: compareAt,
      image:     image
    };
  }

  /* Deduplicate by handle */
  function dedupe(hits) {
    var seen = {};
    return hits.filter(function(p) {
      if (!p.handle || seen[p.handle]) return false;
      seen[p.handle] = true;
      return true;
    });
  }

  /* Core Algolia search — up to 40 hits, deduplicated */
  function doSearch(query, hitsPerPage, callback) {
    var indices = resolvedIndex ? [resolvedIndex] : CANDIDATES.slice();
    var i = 0;

    function tryIndex() {
      if (i >= indices.length) { callback([]); return; }
      var idx = indices[i++];
      fetch(SEARCH_URL(idx), {
        method: 'POST',
        headers: {
          'Content-Type':             'application/json',
          'X-Algolia-Application-Id': APP_ID,
          'X-Algolia-API-Key':        API_KEY
        },
        body: JSON.stringify({
          query:                query || '',
          hitsPerPage:          hitsPerPage || 40,
          distinct:             true,
          attributesToRetrieve: [
            'title', 'handle', 'vendor', 'url',
            'image', 'images',
            'price', 'compare_at_price',
            'variants_min_price', 'variants_min_compare_at_price'
          ]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.hits && data.hits.length > 0) {
          resolvedIndex = idx;
          callback(dedupe(data.hits.map(mapHit)));
        } else if (!resolvedIndex && i < indices.length) {
          tryIndex();
        } else {
          callback(dedupe((data.hits || []).map(mapHit)));
        }
      })
      .catch(function() {
        if (i < indices.length) tryIndex();
        else callback([]);
      });
    }

    tryIndex();
  }

  /* Trending recommendations */
  function fetchTrending(callback) {
    var idx = resolvedIndex || CANDIDATES[0];
    fetch(RECOMMEND_URL, {
      method: 'POST',
      headers: {
        'Content-Type':             'application/json',
        'X-Algolia-Application-Id': APP_ID,
        'X-Algolia-API-Key':        API_KEY
      },
      body: JSON.stringify({
        requests: [{
          model:              'trending-items',
          indexName:          idx,
          maxRecommendations: 12,
          threshold:          0
        }]
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var results = data.results && data.results[0];
      if (results && results.hits && results.hits.length > 0) {
        callback(dedupe(results.hits.map(mapHit)));
      } else {
        /* Fallback: top products from Algolia */
        doSearch('', 12, callback);
      }
    })
    .catch(function() { doSearch('', 12, callback); });
  }

  /* Register adapter with search overlay */
  function register() {
    if (!window.rrSearch || typeof window.rrSearch.setAdapter !== 'function') {
      setTimeout(register, 80);
      return;
    }
    window.rrSearch.setAdapter({
      /* Search: fetch up to 40 deduplicated results from Algolia */
      search: function(q, cb) { doSearch(q, 40, cb); },
      /* Recommend: trending items from Algolia */
      recommend: function(cb) { fetchTrending(cb); }
    });
    console.log('[rr-algolia] v8 ready — full results in overlay, deduplicated.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', register);
  } else {
    register();
  }
})();
